<template>
  <main class="dashboard">
    <div class="d-flex pt-3 pb-2 mb-3 border-bottom" style="gap: 20px">
      <h1 class="h2">{{ current_page.name }}</h1>
      <div class="help-text">
        <ol>
          <li><u>Загрузить ссылки</u> - загрузить ссылки на карточки отзовиков</li>
          <li><u>Запустить парсер</u> - запустить процесс сбора отзывов</li>
          <li><u>Запросить отчтёт</u> - выгрузить собранные данные в отчёт xlsx</li>
        </ol>
      </div>
    </div>
    <div class="text" v-html="current_page.description"></div>


    <div class="card">

      <div class="card-body">
        <div class="button-group">
          <form class="d-flex date-setting" v-if="settings" @submit.prevent="saveSettings">
            <date-picker v-model="settings.review_date_start"
                         locale="ru"
                         :clearable="false"
                         format="dd.MM.yyyy"
                         model-type="yyyy-MM-dd"
                         auto-apply
                         :alt-position="() => ({ top: 30, left: 0 })"
                         :disabled-dates="disabledDates"
                         :enable-time-picker="false"></date-picker>
            <button type="submit" class="btn btn-success btn-sm">Сохранить</button>
            <popper hover placement="top">
              <a href="#" class="text-dark help" @click.prevent><i class="bi bi-question-circle"></i></a>

              <template #content>
                <div class="popover-text">
                  Дата начала сбора отзывов
                </div>
              </template>
            </popper>
          </form>
          <div class="load-btn action-area">


            <button @click.prevent="$modal('show', 'load_links')" class="btn btn-primary btn-sm"><i
                class="bi bi-filetype-xlsx"></i>Загрузить ссылки
            </button>
            <a class="fst-italic" href="https://804303.selcdn.ru/ra_media/media/static/temp/negative_links.xlsx"><i
                class="bi bi-question"></i> пример файла xlsx</a>
            <popper hover placement="top">
              <a href="#" class="text-dark help" @click.prevent><i class="bi bi-question-circle"></i></a>

              <template #content>
                <div class="popover-text">
                  Загрузка ссылок на карточки отзовиков
                </div>
              </template>
            </popper>
          </div>

          <div class="load-btn action-area">
            <button class="btn btn-sm btn-primary" ref="startParserBtn" :disabled="!can_start_parser" @click.prevent="startParser()">Запустить парсер</button>
            <popper hover placement="top">
              <a href="#" class="text-dark help" @click.prevent><i class="bi bi-question-circle"></i></a>

              <template #content>
                <div class="popover-text">
                  Запуск процесса <br> сбора отзывов
                </div>
              </template>
            </popper>
          </div>

          <div class="load-btn action-area">
            <div class="btn-group btn-group-sm" role="group" aria-label="Small button group">
              <button class="btn btn-primary btn-sm" @click="getFileResult"><i class="bi bi-cloud-arrow-down"></i>Запросить
                отчёт
              </button>
              <button class="btn btn-outline-primary btn-sm" @click="showReportSetting"><i
                  class="bi bi-gear-fill"></i>
              </button>
            </div>

            <form action="" v-show="report_setting_show" class="report-settings">

              <label for="">Период</label>
              <div>
                <span>С</span>
                <date-picker v-model="report_setting.start"
                             locale="ru"
                             :clearable="false"
                             format="dd.MM.yyyy"
                             model-type="yyyy-MM-dd"
                             auto-apply
                             :alt-position="() => ({ top: 30, left: 0 })"
                             :disabled-dates="disabledDates"
                             :enable-time-picker="false"></date-picker>
              </div>
              <div>
                <span>По</span>
                <date-picker v-model="report_setting.end"
                             locale="ru"
                             :clearable="false"
                             format="dd.MM.yyyy"
                             model-type="yyyy-MM-dd"
                             auto-apply
                             :alt-position="() => ({ top: 30, left: 0 })"
                             :disabled-dates="disabledDates"
                             :enable-time-picker="false"></date-picker>
              </div>
              <button class="btn btn-outline-primary btn-sm" type="button" @click="getFileResult(report_setting)">
                Запросить
              </button>
            </form>


            <!--            <a v-if="report_link" :href="'https://'+report_link" target="_blank"-->
            <!--               style="font-size: 17px; color: black; text-decoration: underline; z-index: 100"><i class="bi bi-filetype-xlsx"></i>Отчёт-->
            <!--              готов</a>-->
            <popper hover placement="top">
              <a href="#" class="text-dark help" @click.prevent><i class="bi bi-question-circle"></i></a>

              <template #content>
                <div class="popover-text">
                  Выгрузка отчёта по собранным данным в формате xlsx
                </div>
              </template>
            </popper>
          </div>


          <div class="load-btn action-area">
            <router-link :to="{name: 'reviews_monitor_report'}" class="btn btn-outline-primary btn-sm"><i
                class="bi bi-file-ruled"></i> Отчёты
            </router-link>
          </div>

          <div class="load-btn action-area" v-if="report_link">

            <a class="btn btn-success btn-sm" target="_blank" :href="report_link.report_file"><i
                class="bi bi-filetype-xlsx"></i> Отчёт готов</a>
          </div>


          <div class="action-area settings ms-auto">
            <router-link active-class="active" class="btn btn-sm btn-outline-dark" title="Настройки"
                         :to="{name: 'reviews_monitor_setting'}">
              <i class="bi bi-gear"></i>
            </router-link>
            <popper hover>
              <a href="#" class="text-dark help" @click.prevent><i class="bi bi-question-circle"></i></a>

              <template #content>
                <div class="popover-text">
                  Настройки раздела
                </div>
              </template>
            </popper>
          </div>
        </div>
      </div>
      <div class="card-header">
        <div class="btn-toolbar mb-2 mb-md-0 filters">
          <div class="form-floating ms-2">
            <select class="form-select" id="domain" v-model="filters.domain" aria-label="Домены" key="domain">
              <option value=""></option>
              <option v-for="domain in domains" :value="domain.id">{{ domain.domain }}</option>
            </select>
            <label for="domain">Домены</label>
          </div>
          <div class="form-floating ms-2">
            <select class="form-select" id="domain" v-model="filters.group" aria-label="группы" key="group">
              <option value=""></option>
              <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
            </select>
            <label for="domain">Группы</label>
          </div>
          <div class="form-floating ms-2">
            <input type="text" id="search_review" v-model="filters.search" class="form-control">
            <label for="search_review">Поиск</label>
          </div>

          <button type="button" class="btn btn-primary ms-2 btn-sm" @click="page=1;getData()">
            <i class="bi bi-search"></i> <span>Показать</span></button>

          <div style="margin-left: auto" v-if="all_count && in_parser_process && in_parser_process > 0">
            <span>Прогресс: {{ all_count - in_parser_process }}/{{ all_count }}</span>
            <div class="progressbar">
              <span :style="{width: (all_count-in_parser_process)/all_count*100 +'%'}"></span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="table-flex-responsive">

      <div class="row header sticky">
        <div class="col-1"> №
          <input id="check_all" type="checkbox" name="check_links"
                 :checked="check_links.length === objects.length"
                 @change="check_links=check_links.length === objects.length?[]:objects.map(x=>x.id);"></div>
        <div class="col-5">Ссылка на сайт отзовик</div>
        <div class="col">Группа</div>
        <div class="col-3">Информация о последнем сборе</div>
        <div class="col">

          <div class="d-flex common-button" style="gap: 5px" v-if="check_links.length">
            <button class="btn btn-sm btn-warning" @click.prevent="massRestart()" title="Запустить сбор отзывов"><i
                class="bi bi-arrow-clockwise"></i></button>

            <button class="btn btn-sm btn-danger" title="Удалить" @click="massDelete()"><i
                class="bi bi-trash"></i></button>
          </div>

        </div>
      </div>
      <template v-for="(object, index) in objects">
        <div class="row line">

          <div class="col-1 number">
            <div class="sub-head">№</div>
            <input :id="object.id" type="checkbox" name="check_links"
                   :value="object.id" v-model="check_links">
            {{ (index + 1) + ((page - 1) * size) }}
          </div>
          <div class="col sub-head">Ссылка на сайт отзовик</div>
          <div class="col-lg-5">
            <template v-if="object.edit">
              <div :class="object.link_error?'form-group--error':''">
                <label class="d-none">Сайт</label>
                <input class="form-control" type="url" v-model="object.link"
                       v-on:keyup="object.link_error = false">
              </div>
              <div class="error" v-if="object.link_error">{{ object.link_error }}</div>

            </template>
            <template v-else>
              <router-link active-class="active" class="text-dark break-anyway"
                           :to="`/reviews_monitor/${object.id}/`">
                {{ object.link }}
              </router-link>
              <br>
              <span style="font-size: 10px; color: #5faedf;"><i class="bi bi-clock-history"></i> Количество запусков парсера {{
                  object.parser_count
                }}</span>
            </template>
          </div>
          <div class="col sub-head">Группа</div>
          <div class="col">
            <template v-if="!object.add_group">
              <div class="d-flex">
                <select name="" id="" class="form-control" @change="changeGroup(object)" v-model="object.group">
                  <option v-for="group in groups" :value="group">{{ group.name }}</option>
                </select>
                <button class="btn btn-outline-success btn-sm" @click="object.add_group = {name: ''}">+</button>
              </div>
            </template>
            <template v-else>
              <div class="d-flex">
                <input class="form-control" placeholder="Название группы" v-model="object.add_group.name">
                <button class="btn btn-sm btn-success" @click="createGroup(object)" title="Сохранить"><i
                    class="bi bi-check-lg"></i></button>
                <button class="btn btn-sm btn-danger" @click="object.add_group=null" title="Отмена">X</button>
              </div>
            </template>
          </div>
          <div class="col sub-head">Информация о последнем сборе</div>
          <div class="col-3">
                   <span class="status ms-auto" v-if="object.parser?.id && !object.parser?.collect_data">
                      <span class="process"></span>
                      <span>В процессе сбора</span>
                    </span>
            <span class="status" v-else-if="object.parser?.id">
                      <span>Период: {{
                          $moment(object.parser.date_start).format("DD.MM.YY")
                        }} - {{ $moment(object.parser.date_end).format("DD.MM.YY") }}</span>
                      <span>Отзывов:  <router-link :to="`/reviews_monitor/${object.id}/`">
                      <div class="badge bg-dark"> {{ object.parser.review_count || 0 }}</div>
                    </router-link></span>
                      <span>Дата запуска: {{ $moment(object.parser.date_create).format("DD.MM.YY HH:mm") }}</span>
                    </span>

          </div>

          <div class="col">
            <template v-if="!object.edit">
              <div class="d-flex" style="gap: 5px">
                <button class="btn btn-sm btn-warning"
                        v-if="(object.parser?.id && object.parser?.collect_data) || !object.parser?.id"
                        @click.prevent="openRestart(object)" title="Запустить сбор отзывов"><i
                    class="bi bi-arrow-clockwise"></i></button>
                <button class="btn btn-sm btn-secondary" v-else title="Перезапуск не доступен"><i
                    class="bi bi-arrow-clockwise"></i></button>
                <button class="btn btn-sm btn-danger" title="Удалить" @click="deleteObject(object)"><i
                    class="bi bi-trash"></i></button>


              </div>
            </template>
            <template v-else>
              <button class="btn btn-sm btn-secondary" @click="endEdit(object)">Отмена</button>
              <button class="btn btn-sm btn-success" @click="saveNote(object)">Сохранить</button>
            </template>


          </div>
        </div>
      </template>
      <div v-if="!objects.length" class="row">
        <div class="col-12 text-center">
          Не добавлено ни одной записи
        </div>
      </div>
      <div v-if="objects.length < max_length">
        <div>
          <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
        </div>
      </div>
    </div>


    <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>


    <modal modal_id="add_site">
      <template v-slot:header>
        <h4 v-if="modal_data">Сбор данных на следующих доменах не подерживается</h4>
        <h4 v-else>Успешно загружено</h4>
      </template>
      <template v-slot:body>
        <div v-if="save_answer.length">
          <p v-for="error in save_answer">{{ error }}</p>
        </div>

        <div v-if="modal_data.length">
          <strong>Неподдерживаемые домены:</strong>
          <ul style="height: 150px; overflow: auto;">
            <li v-for="modal_d in modal_data">{{ modal_d }}</li>
          </ul>
        </div>
        <p v-if="modal_data">Вы можете отправить обращение о возможности добавить поддержку доменов</p>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'add_site')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" v-if="modal_data" class="btn btn-primary" @click="sendRequest"
                data-bs-dismiss="modal">Отправить
        </button>
      </template>
    </modal>
    <modal modal_id="restart_one">
      <template v-slot:header>
        <h4>Перезапуск сбора данных</h4>
        <div class="restart-info">
          <span v-if="settings?.review_date_start"><i
              class="bi bi-gear-fill"></i> Дата указанная в настройках: {{ settings.review_date_start }}</span>
          <span v-if="restart_link"><i class="bi bi-clock-history"></i> Последний сбор: {{
              restart_link.parser?.date_end ? restart_link.parser?.date_end : 'не запускалось'
            }}</span>
        </div>
      </template>
      <template v-slot:body>

        <strong>Выберите дату начала сбора данных</strong>
        <date-picker v-if="restart_date" v-model="restart_date" style="width: 300px"
                     position="right"
                     locale="ru"
                     :clearable="false"
                     format="dd.MM.yyyy"
                     model-type="yyyy-MM-dd"
                     auto-apply
                     :enable-time-picker="false"></date-picker>
        <div style="margin-bottom: 280px"></div>
      </template>
      <template v-slot:footer>

        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'restart_one')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" class="btn btn-primary" @click="startParser(restart_link.id)"
                data-bs-dismiss="modal">Запустить
        </button>
      </template>
    </modal>
    <modal modal_id="not_date">
      <template v-slot:header>
        <h4>Не указана дата начала сбора отзывов</h4>
      </template>
      <template v-slot:body>
        <p>
          Укажите дату начала сбора отзывов в
          <router-link active-class="active" class="btn btn-sm btn-outline-dark" title="Настройки"
                       :to="{name: 'reviews_monitor_setting'}">
            Настройках
          </router-link>
        </p>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'not_date')"
                data-bs-dismiss="modal">Закрыть
        </button>
      </template>
    </modal>
    <modal modal_id="load_links">
      <template v-slot:header>
        <h4>Введите ссылки или загрузите файл</h4>
      </template>
      <template v-slot:body>
        <div class="form-item">
          <label for="">Выберите группу</label>
          <template v-if="!create_group">
            <div class="d-flex">
              <select name="" id="" class="form-control" v-model="load.group">
                <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
              </select>
              <button class="btn btn-outline-success btn-sm" @click="create_group = {name: ''}">Добавить</button>
            </div>
          </template>
          <template v-else>
            <div class="d-flex">
              <input class="form-control" placeholder="Название группы" v-model="create_group.name">
              <button class="btn btn-sm btn-success" @click="createGroup()">Сохранить</button>
              <button class="btn btn-sm btn-danger" @click="create_group=null">X</button>
            </div>
          </template>
        </div>
        <div class="form-item">
          <label for="">Введите ссылки<sup>*</sup> <sub>(каждая ссылка с новой строки)</sub></label>
          <textarea v-model="load.text" name="" id="" cols="30" rows="30" style="height: 150px"
                    class="form-control"></textarea>
        </div>
        <div class="form-item">
          <label for="">Или загрузите файл<sup>*</sup> </label>
          <input type="file" ref="load_link" class="form-control"
                 accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        </div>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'load_links')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" class="btn btn-success" @click="sendFile($refs.load_link)"
                data-bs-dismiss="modal">Загрузить
        </button>
      </template>
    </modal>


  </main>
</template>

<script>
import dataMixin from '../mixins.js';
import {DictionaryApi} from '@/api/dictionary'
import {Line} from "vue-chartjs";
import ReviewStatus from "./ReviewStatus.vue"
import {state} from "@/socket";

export default {
  name: 'ReviewSites',
  components: {Line, ReviewStatus},
  mixins: [dataMixin],
  data() {
    return {
      name: 'reviews_monitor',
      save_answer: [],
      check_links: [],
      domains: [],
      groups: [],

      create_group: null,
      report_link: null,
      chatSocket: null,
      restart_link: null,
      restart_date: null,
      filters: {domain: "", search: "", group: ""},
      settings: null,
      report_setting: {},
      load: {},
      in_parser_process: null,
      can_start_parser: false,
      report_setting_show: false,
      empty: {
        link: '',
        edit: true
      },
      validate: {
        link: {
          func: (o) => {
            return !o.link || !this.$func.isURL(o.link)
          }, error: 'Неверный формат ссылки'
        },
      }
    }
  },
  watch: {
    // ws_state(val) {
    //   const review = this.objects.findIndex(x => x.id === val.id)
    //
    //   if (val.parser?.collect_data) {
    //     if (!this.in_parser_process) {
    //       this.getStatus()
    //     } else {
    //       this.in_parser_process -= 1
    //     }
    //   }
    //   // this.getStatus()
    //   if (review >= 0) {
    //     this.objects.splice(review, 1, val);
    //   }
    // },
    // ws_parser_report(val) {
    //   this.report_link = val;
    // },
  },
  mounted() {
    DictionaryApi.get_review_settings(this.name).then(response => this.settings = response)
    DictionaryApi.review_domain_list(this.name).then(response => this.domains = response)
    DictionaryApi.review_group_list(this.name).then(response => this.groups = response)
    this.getStatus()
    this.connectChatWs()

  },
  methods: {
    connectChatWs() {
      const $this = this;
      const URL = `${location.protocol.includes("https") ? "wss" : "ws"}://${this.$NODE_ENV === "development" ? this.$VUE_APP_WS_URL : location.host}/ws/`
      this.chatSocket = new WebSocket(
          `${URL}reviews/${this.$store.getters.user.organization_obj_id}/`
      );

      this.chatSocket.onmessage = function (e) {
        let data = JSON.parse(e.data)
        if (data.content_type === "review") {
          if (data.object.parser?.collect_data) {
            $this.in_parser_process -= 1
          }
          const review = $this.objects.findIndex(x => x.id === data.object.id)
          if (review >= 0) {
            $this.objects.splice(review, 1, data.object);
          }
        }
        if (data.content_type === "parser_report") {
          $this.report_link = data.object;
        }
        if (data.content_type === "parser_start") {
          $this.getStatus()
        }
      };

    },
    changeGroup(object) {
      DictionaryApi.review_group_set(this.name, object.id, {group_id: object.group.id})
    },
    createGroup(object) {
      const $this = this;
      let data = object ? object.add_group : this.create_group;
      console.log(object)
      if (data.name) {
        DictionaryApi.review_group_add(this.name, data).then(group => {
          $this.groups.push(group)
          if (object) {
            object.group = group;
            object.add_group = null;
            $this.changeGroup(object);
          } else {
            $this.load.group = group.id
            $this.create_group = null
          }
        })
      } else {
        $this.$notify({
          type: "error",
          text: 'Введите название'
        })
      }
    },

    disabledDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    sendRequest() {
      const $this = this;
      DictionaryApi.request_domain(this.name, this.modal_data).then(() => {
        $this.$modal("hide", "add_site")
        $this.$notify({
          type: "success",
          text: 'Обращение отправлено'
        })
      })
    },
    showReportSetting() {
      this.report_setting_show = !this.report_setting_show;
      if (!this.report_setting_show) this.report_setting = {};
    },
    saveSettings() {
      const $this = this;
      DictionaryApi.save_review_settings(this.name, this.settings).then(() => {
        $this.$notify({
          type: "success",
          text: 'Настройки сохранены'
        })
      })
    },
    openRestart(object) {

      if (!this.settings.review_date_start) {
        this.$notify({
          type: "error",
          text: "Укажите дату начала сбора"
        })
        this.$modal("show", "not_date")
      } else {
        this.restart_link = object
        this.restart_date = object.parser?.id ? object.parser.date_end : this.settings.review_date_start
        this.$modal('show', 'restart_one')
      }
    },
    getStatus() {
      DictionaryApi.current_status(this.name, this.$store.getters.user.organization_obj_id).then(response => {
        this.in_parser_process = response.count;
        if (!response.key) this.can_start_parser = true;
      })
    },
    massRestart() {
      let objects = this.objects.filter(x => this.check_links.indexOf(x.id) + 1)
      objects.forEach(object => {
        this.startParser(object)
      })
      this.check_links = []
    },
    massDelete() {
      let objects = this.objects.filter(x => this.check_links.indexOf(x.id) + 1)
      objects.forEach(object => {
        this.deleteObject(object)
      })
      this.check_links = []

    },
    startParser(link_id) {
      const $this = this;
      let data = {link: link_id, date: this.restart_date}
      this.$refs.startParserBtn.setAttribute("disabled", true)
      this.can_start_parser = false;
      DictionaryApi.start_parser(this.name, data).then(response => {
        if (response.modal) $this.$modal("show", response.modal)
        if (response.error) $this.$notify({
          type: "error",
          text: response.error
        })
        else $this.$notify({
          type: "success",
          text: "Сбора данных запущен"
        })
        $this.$modal('hide', 'restart_one')
        // setTimeout(()=>$this.getStatus(), 3000)

      })
    },
    deleteObject(object) {
      DictionaryApi.delete(this.name, object.id).then(() => this.objects.splice(this.objects.indexOf(object), 1))
    },

    getFileResult: function (settings) {
      let $this = this;
      $this.report_link = null;
      DictionaryApi.download_file(this.name, settings).then(response => {
        this.report_setting_show = false;
        this.report_setting = {};
        this.$notify({
          type: 'success ',
          text: 'Отчёт отправлен на формирование'
        });
        // $this.$notify({
        //   type: "success",
        //   title: "Отчёт готов",
        //   text: 'Скачайте его по ссылке'
        // })
      }).catch(error => {
        $this.$notify({
          type: "error",
          text: 'Ошибка создания отчёта'
        })
        console.error('Ошибка загрузки файла:', error);
      });
    },

    sendFile(ref) {
      const $this = this;
      let formData = new FormData();
      formData.set('file', ref.files[0]);
      formData.set('text', this.load.text);
      formData.set('group', this.load.group);
      if (ref.files[0] || this.load.text) {
        DictionaryApi.load_file(this.name, formData).then(response => {
          if (response.answer) $this.save_answer = response.answer;
          if (response.message) {
            $this.$notify({
              type: response.message.status,
              text: response.message.text
            })
          }
          if (response.answer) {
            $this.save_answer = response.answer;
            if (response.domains) $this.modal_data = response.domains
            $this.$modal('hide', 'load_links')
            $this.$modal('show', "add_site")
          }

          $this.$refs.load_link.value = null;
          $this.getData()
        })
      } else {
        $this.$notify({
          type: "error",
          text: 'Загрузите файл или заполните текстовое поле'
        })
      }


    }

  }
}
</script>
<style>

.date-setting input {
  height: 24px !important;
  font-size: 14px !important;
}
</style>
<style scoped lang="scss">
.button-group {
  display: flex;
  gap: 14px;
  flex: 1 1 auto;
  align-items: flex-start;

  .ms-lg-auto {
    align-items: flex-start;
    gap: 15px;
  }

  .load-btn {
    display: flex;
    flex-direction: column;

    span, a:not(.btn) {
      font-size: 10px;
    }
  }
}

.restart-info {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: max-content;
  padding: 5px 20px;
  margin-bottom: 20px;
  height: 50px;
}

.date-setting {
  display: flex;
  gap: 5px;
  align-items: center;
  border: 1px solid #cecece;
  padding: 3px;
  border-radius: 5px;
  position: relative;

  .help {
    position: absolute;
    top: -10px;
    right: -10px;

    .bi-question-circle {
      font-size: 10px;
    }
  }


  button {
    height: 24px;
    line-height: 10px;
  }
}

.status {
  display: flex;
  flex-direction: column;
  align-items: start;
  font-size: 10px;

  .process {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: block;
    margin: 0 auto;
    position: relative;
    background: #F0F0F0FF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #F0F0F0FF;
    box-sizing: border-box;
    animation: shadowPulse 2s linear infinite;
  }
}


@keyframes shadowPulse {
  33% {
    background: #F0F0F0FF;
    box-shadow: -24px 0 #f88705, 24px 0 #F0F0F0FF;
  }
  66% {
    background: #f88705;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #F0F0F0FF;
  }
  100% {
    background: #FFF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #f88705;
  }
}

.report-settings {
  position: absolute;
  top: 35px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  padding: 10px;
  display: flex;
  gap: 5px;
  align-items: center;
  flex-direction: column;
  z-index: 10;

  div {
    display: flex;
    gap: 5px;
    align-items: center;

    span {
      width: 15px;
    }

  }
}

.help-text {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 100 100"><text x="50" y="60" font-size="80" text-anchor="middle" fill="rgba(147,211,251,0.8)" transform="rotate(-30, 50, 60)">?</text></svg>');
  background-repeat: no-repeat;
  background-position: left;
  font-size: 12px;
  line-height: 12px;
  border: 1px solid #93d3fb;
  padding: 5px 5px 5px 15px;
  border-radius: 5px;

  ol {
    margin: 0;
    padding-left: 15px;
  }
}

.action-area {
  position: relative;

  .help {
    position: absolute;
    top: -10px;
    right: -10px;

    .bi-question-circle {
      font-size: 10px;
    }
  }

}

.header.sticky {
  position: sticky;
  top: -20px;
}

.popover-text {
  min-width: 150px;
  //white-space: nowrap;
}

.card-header {
  .form-floating {
    label {
      padding: 0;
      margin: 5px 0 0 5px;
      height: 18px;
      font-size: 14px;
    }

    input, select {
      padding: 5px 0 0 8px !important;
      height: 31px !important;
      min-height: 31px !important;
      font-size: 12px;
    }
  }
}

@media (width < 768px) {
  .button-group {
    flex-wrap: wrap;

    > * {
      order: 1;
    }

    button {
      font-size: 12px;
    }

    .date-setting {
      order: -1;
    }

    .settings {
      order: 0;
    }
  }
  .filters {
    .form-floating {
      width: 40%;
      min-width: 40%;

      select, input {
        min-width: auto;
      }
    }

    button span {
      display: none;
    }
  }
}

.progressbar {
  height: 14px;
  position: relative;
  background: #fff;
  padding: 0;
  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 250px;

  span {
    display: block;
    height: 100%;
    background-color: rgb(135, 206, 250);
    background-image: linear-gradient(center bottom, rgb(135, 206, 250) 37%, rgb(135, 206, 250) 69%);
    box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
    position: relative;
    overflow: hidden;
  }
}

.common-button {
  button {
    width: 55px;
    border: 1px solid #000;
  }
}

</style>


